import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import "../assets/styles/Main.scss";
import mk_photo_version_2 from "../assets/avatar/mk_photo_version_2.jpg";

function Main({ parentToChild }: any) {
	// const { mode } = parentToChild;

	return (
		<div className="container">
			<div className="about-section">
				<div className="image-wrapper">
					<img src={mk_photo_version_2} alt="Avatar" />
				</div>
				<div className="content">
					<div className="social_icons">
						<a
							href="https://github.com/meruyert93"
							target="_blank"
							rel="noreferrer"
						>
							<GitHubIcon />
						</a>
						<a
							href="https://www.linkedin.com/in/meruyert-karim/"
							target="_blank"
							rel="noreferrer"
						>
							<LinkedInIcon />
						</a>
					</div>
					<h1>Meruyert (Mika) Karim</h1>
					<p>Software Engineer</p>

					<div className="mobile_social_icons">
						<a
							href="https://github.com/meruyert93"
							target="_blank"
							rel="noreferrer"
						>
							<GitHubIcon />
						</a>
						<a
							href="https://www.linkedin.com/in/meruyert-karim/"
							target="_blank"
							rel="noreferrer"
						>
							<LinkedInIcon />
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Main;
